<div class="pageContent">
  <div class="pageTitle">
    <h2>Visor de Reportería</h2>
  </div>

  <!-- Panel de filtros -->
  <div class="visor-filtros-panel">
    <div class="visor-filtros-row">

      <!-- Selector de proceso -->
      <div class="visor-field visor-field--proceso">
        <div class="ms-Dropdown dropdown" tabindex="0">
          <label class="ms-Label is-required">Proceso</label>
          <i class="ms-Dropdown-caretDown ms-Icon ms-Icon--ChevronDown"></i>
          <select
            class="form-control"
            [(ngModel)]="idProcesoSeleccionado"
            (change)="onProcesoChange()"
            [disabled]="cargandoProcesos"
          >
            <option [ngValue]="null" disabled>
              {{ cargandoProcesos ? 'Cargando procesos con reportes configurados...' : 'Seleccione un proceso...' }}
            </option>
            <option *ngFor="let p of procesosDisponibles" [ngValue]="p.Id">{{ p.Nombre }}</option>
          </select>
        </div>
      </div>

      <!-- Fecha desde -->
      <div class="visor-field" *ngIf="habilitarBusquedaFechas">
        <label class="ms-Label">Fecha desde</label>
        <input
          type="date"
          class="ms-TextField-field visor-date-input"
          [(ngModel)]="fechaDesde"
        />
      </div>

      <!-- Fecha hasta -->
      <div class="visor-field" *ngIf="habilitarBusquedaFechas">
        <label class="ms-Label">Fecha hasta</label>
        <input
          type="date"
          class="ms-TextField-field visor-date-input"
          [(ngModel)]="fechaHasta"
        />
      </div>

      <div class="visor-field visor-field--info" *ngIf="tipoOrigenActual === 'Vista' && habilitarBusquedaFechas && columnaFechaVistaConfig">
        <label class="ms-Label">Columna de fecha (Vista)</label>
        <div class="visor-info-chip">{{ columnaFechaVistaConfig }}</div>
      </div>

      <!-- Botones -->
      <div class="visor-field visor-field--buttons">
        <label class="ms-Label">&nbsp;</label>
        <div class="visor-buttons-group">
          <button
            class="ms-Button ms-Button--primary"
            type="button"
            (click)="buscarReporte()"
            [disabled]="cargandoDatos || !idProcesoSeleccionado"
          >
            <span class="ms-CommandButton-icon">
              <i class="ms-Icon ms-Icon--Search"></i>
            </span>
            <span class="ms-Button-label">{{ cargandoDatos ? 'Cargando...' : 'Buscar' }}</span>
          </button>
          <button
            class="ms-Button"
            type="button"
            (click)="limpiarFiltros()"
            [disabled]="cargandoDatos"
          >
            <span class="ms-Button-label">Limpiar</span>
          </button>
          <button
            class="ms-Button"
            type="button"
            (click)="descargarExcel()"
            [disabled]="cargandoDatos || descargandoExcel || !idProcesoSeleccionado"
          >
            <span class="ms-CommandButton-icon">
              <i class="ms-Icon ms-Icon--ExcelLogo"></i>
            </span>
            <span class="ms-Button-label">{{ descargandoExcel ? 'Exportando...' : 'Descargar Excel' }}</span>
          </button>
        </div>
      </div>

    </div>
  </div>

  <!-- Spinner cargando -->
  <div *ngIf="cargandoDatos" class="visor-spinner">
    <div class="ms-Spinner">
      <div class="ms-Spinner-label">Cargando reporte...</div>
    </div>
  </div>

  <!-- Sin columnas configuradas -->
  <div *ngIf="reporteCargado && columnasSinConfig && !cargandoDatos" class="visor-empty-state">
    <i class="ms-Icon ms-Icon--BarChart4 visor-empty-icon"></i>
    <p class="ms-font-l">Este proceso no tiene columnas configuradas.</p>
    <p class="ms-font-s ms-fontColor-neutralSecondary">
      Acceda al <strong>Administrador de Reportería</strong> para definir qué
      variables de flujo se mostrarán como columnas en el reporte.
    </p>
  </div>

  <!-- Resultado del reporte -->
  <ng-container *ngIf="reporteCargado && !columnasSinConfig && !cargandoDatos">

    <!-- Encabezado de tabla: info + selector de página -->
    <div class="visor-table-header">
      <span class="ms-font-s ms-fontColor-neutralSecondary">
        Mostrando <strong>{{ filas.length }}</strong> de <strong>{{ recordsFiltered }}</strong> registros.
      </span>
      <div class="visor-pagesize-wrap">
        <span class="ms-font-s ms-Label">Registros por página:</span>
        <div class="ms-Dropdown dropdown visor-pagesize-dropdown" tabindex="0">
          <i class="ms-Dropdown-caretDown ms-Icon ms-Icon--ChevronDown"></i>
          <select class="form-control" [(ngModel)]="pageSize" (change)="onPageSizeChange()">
            <option *ngFor="let ps of pageSizeOptions" [ngValue]="ps">{{ ps }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Tabla -->
    <div class="visor-table-scroll">
      <table class="ms-Table ms-Table--selectable order-column row-border visor-table">
        <thead>
          <tr>
            <th class="visor-col-consulta">Consulta</th>
            <th *ngFor="let col of columnasVisiblesTabla">{{ col.Etiqueta }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let fila of filas" [class.visor-row-historico]="fila.EsHistorico">
            <td class="visor-col-consulta">
              <div style="display:flex; gap:6px; align-items:center; justify-content:center; flex-wrap:wrap;">
                <button
                  type="button"
                  class="ms-CommandButton-button opt-button"
                  title="Consultar detalle"
                  (click)="abrirConsulta(fila)"
                >
                  <span class="ms-CommandButton-icon ms-fontColor-themePrimary">
                    <i class="ms-Icon ms-Icon--View"></i>
                  </span>
                </button>
                <button
                  *ngIf="tipoOrigenActual === 'Variables' && habilitarHistorico && !fila.EsHistorico && fila.IdEjecucion"
                  type="button"
                  class="ms-CommandButton-button opt-button"
                  title="Consultar histórico"
                  (click)="abrirHistorico(fila)"
                >
                  <span class="ms-CommandButton-icon ms-fontColor-themePrimary">
                    <i class="ms-Icon ms-Icon--History"></i>
                  </span>
                </button>
              </div>
            </td>
            <td *ngFor="let col of columnasVisiblesTabla">
              {{ getValorColumna(fila, col) }}
            </td>
          </tr>
          <tr *ngIf="filas.length === 0">
            <td [attr.colspan]="1 + columnasVisiblesTabla.length" class="visor-no-data">
              No hay ejecuciones que coincidan con los filtros aplicados.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    <div class="visor-pagination" *ngIf="totalPages > 1">
      <button
        class="ms-Button visor-page-btn"
        type="button"
        (click)="goToPage(1)"
        [disabled]="currentPage === 1"
        title="Primera página"
      >
        <i class="ms-Icon ms-Icon--Previous"></i>
      </button>
      <button
        class="ms-Button visor-page-btn"
        type="button"
        (click)="goToPage(currentPage - 1)"
        [disabled]="currentPage === 1"
        title="Página anterior"
      >
        <i class="ms-Icon ms-Icon--ChevronLeft"></i>
      </button>

      <button
        *ngFor="let p of pages"
        class="ms-Button visor-page-btn"
        [class.ms-Button--primary]="p === currentPage"
        type="button"
        (click)="goToPage(p)"
      >
        {{ p }}
      </button>

      <button
        class="ms-Button visor-page-btn"
        type="button"
        (click)="goToPage(currentPage + 1)"
        [disabled]="currentPage === totalPages"
        title="Página siguiente"
      >
        <i class="ms-Icon ms-Icon--ChevronRight"></i>
      </button>
      <button
        class="ms-Button visor-page-btn"
        type="button"
        (click)="goToPage(totalPages)"
        [disabled]="currentPage === totalPages"
        title="Última página"
      >
        <i class="ms-Icon ms-Icon--Next"></i>
      </button>

      <span class="ms-font-s ms-fontColor-neutralSecondary visor-page-info">
        Página {{ currentPage }} de {{ totalPages }}
      </span>
    </div>

    <div class="visor-historico-panel" *ngIf="mostrarHistorico">
      <div class="visor-historico-header">
        <h3 class="ms-font-xl">Histórico de ejecución</h3>
        <div class="visor-historico-actions">
          <button
            class="ms-Button"
            type="button"
            (click)="descargarExcelHistorico()"
            [disabled]="descargandoExcelHistorico || historialCargando || historialActual.length === 0"
          >
            <span class="ms-Button-label" *ngIf="!descargandoExcelHistorico">Descargar Excel</span>
            <span class="ms-Button-label" *ngIf="descargandoExcelHistorico">Generando...</span>
          </button>
          <button class="ms-Button" type="button" (click)="cerrarHistorico()">
            <span class="ms-Button-label">Cerrar histórico</span>
          </button>
        </div>
      </div>

      <div *ngIf="historialCargando" class="visor-spinner">
        <div class="ms-Spinner">
          <div class="ms-Spinner-label">Cargando histórico...</div>
        </div>
      </div>

      <div *ngIf="!historialCargando && historialActual.length === 0" class="visor-empty-state">
        <i class="ms-Icon ms-Icon--History visor-empty-icon"></i>
        <p class="ms-font-l">No hay historial disponible para esta ejecución.</p>
      </div>

      <div class="visor-table-scroll" *ngIf="!historialCargando && historialActual.length > 0">
        <table class="ms-Table ms-Table--selectable order-column row-border visor-table">
          <thead>
            <tr>
              <th class="visor-col-consulta">Consulta</th>
              <th *ngFor="let col of columnasVisiblesHistorico">{{ col.Etiqueta }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let filaHistorico of historialActual">
              <td class="visor-col-consulta">
                <button
                  type="button"
                  class="ms-CommandButton-button opt-button"
                  title="Consultar detalle"
                  (click)="abrirConsulta(filaHistorico)"
                >
                  <span class="ms-CommandButton-icon ms-fontColor-themePrimary">
                    <i class="ms-Icon ms-Icon--View"></i>
                  </span>
                </button>
              </td>
              <td *ngFor="let col of columnasVisiblesHistorico">
                {{ getValorColumnaGenerica(filaHistorico, col) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </ng-container>
</div>

<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader modal-consulta-reporteria" appPreventOutsideClick>
    <div class="ms-Dialog-title">
      Consulta de variables - {{ nombreProcesoSeleccionado }}
    </div>
    <div class="ms-Dialog-content visor-consulta-content">
      <div class="visor-consulta-grid" *ngIf="filaConsulta as fila">
        <div class="visor-consulta-item" *ngFor="let col of columnasConfiguradas">
          <label class="ms-Label">{{ col.Etiqueta }}</label>
          <input
            *ngIf="col.TipoControl === 'input'"
            type="text"
            class="ms-TextField-field visor-consulta-input"
            [value]="getValorColumna(fila, col, true)"
            readonly
          />
          <textarea
            *ngIf="col.TipoControl === 'areatext'"
            class="ms-TextField-field visor-consulta-textarea"
            [value]="getValorColumna(fila, col, true)"
            rows="4"
            readonly
          ></textarea>
        </div>
      </div>
    </div>
    <div class="ms-Dialog-actions">
      <button class="ms-Button ms-Dialog-action ms-Button--primary" type="button" (click)="cerrarConsulta()">
        <span class="ms-Button-label">Cerrar</span>
      </button>
    </div>
  </div>
</div>

<app-modal-notify #notifyModal></app-modal-notify>
